import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { createUseStyles } from 'react-jss'
import { MUIFormTextInput } from '../@Common/Form/TextInput/FormTextInput'
import Button from '../Button'
import { colors } from '../../../design-system/tokens'
import { useGetBackChannelLogoutUriQuery } from '../../redux/slices/sessionsSlice'
import useClientBackChannelLogout from './useClientBackChannelLogout'

const useStyles = createUseStyles({
  footer: {
    height: 'auto',
    backgroundColor: colors.background.muted,
    padding: '10px 30px',
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: '-20px',
  },
})

function ClientBackChannelLogoutField({ clientId }) {
  const classes = useStyles()
  const { data, isLoading } = useGetBackChannelLogoutUriQuery(clientId, { skip: !clientId })
  const { control, handleSubmit, reset } = useForm({
    defaultValues: { backChannelLogoutUri: '' },
  })
  const { save, isSaving } = useClientBackChannelLogout()

  useEffect(() => {
    if (data) {
      reset({ backChannelLogoutUri: data.backChannelLogoutUri || '' })
    }
  }, [data, reset])

  const onSubmit = handleSubmit((values) => save(clientId, values.backChannelLogoutUri))

  if (isLoading) {
    return <div className="text-sm text-gray-medium" data-gxid="backchannel-logout-loading">Loading…</div>
  }

  return (
    <form onSubmit={onSubmit} data-gxid="backchannel-logout-form">
      <MUIFormTextInput
        name="backChannelLogoutUri"
        control={control}
        label="Back-channel logout URL"
      />
      <div className={classes.footer}>
        <Button label="Save" color="primary" disabled={isSaving}>
          Save
        </Button>
      </div>
    </form>
  )
}

ClientBackChannelLogoutField.propTypes = {
  clientId: PropTypes.string.isRequired,
}

export default ClientBackChannelLogoutField
